import { Outlet } from 'react-router-dom';

function MyDashboardsPlusTasksPage() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default MyDashboardsPlusTasksPage;
